import { Button } from '@mui/material';
import React from 'react';

const CategoryButton = ({ variant, disabled, onCategoryClick, name = '', children }) => (
  <Button
    variant={variant instanceof Function ? variant() : variant || 'outlined'}
    size="small"
    color="secondary"
    disabled={disabled}
    onClick={onCategoryClick}
    sx={{ marginTop: 1, marginRight: 2, borderRadius: '28px' }}
    data-testid={name}
  >
    {children}
  </Button>
);

export default CategoryButton;
